export const et = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Tagasi",
        save: "Salvesta",
        saved: "Salvestatud",
        cancel: "Tühista",
        close: "Sulge",
        accessDenied: "Juurdepääs keelatud",
        noExportPermission: "Teil ei ole õigust selle auto andmeid eksportida.",
        delete: "Kustuta",
        downgrade: "Alandamine",
        downgradeConfirm: "Kas olete kindel, et soovite alandada tasuta plaanile?",
        edit: "Muuda",
        loading: "Laadimine...",
        confirm: "Kinnita",
        processing: "Töötlemine...",
        history: "Ajalugu",
        currentCar: "Praegune auto",
        purchasedCarTitle: "Auto Ost",
        initialCost: "Esialgne Kulu",
        done: "Valmis",
        ok: "OK",
        error: "Viga",
        errorSaving: "Andmete salvestamise viga",
        mandatoryFieldsError: "Palun täitke kõik kohustuslikud väljad õigesti.",
        search: "Otsi",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Vale e-posti formaat",
        today: "Täna",
        car: "Auto",
        all: "Kõik",
        deleteConfirm: "Kustuta",
        unsavedChangesTitle: "Salvestamata Muudatused",
        unsavedChangesMessage: "Kas soovite enne lahkumist muudatused salvestada?",
        dontSave: "Ära salvesta",
        additionalOptions: "Lisavalikud",
        add: "Lisa",
        fileTooLarge: "Fail on liiga suur. Maksimaalne suurus on {limit} MB.",
        storageFull: "Salvestuspiirang ületatud. Maksimaalne salvestus on {limit} MB.",
        dailyUploadLimit: "Päevane üleslaadimise limiit täis ({limit} faili/päev). Proovi homme uuesti.",
        hourlyUploadLimit: "Tunnimine üleslaadimise limiit täis ({limit} faili/tund). Proovi tunni pärast uuesti.",
        fileCountLimit: "Maksimaalne {limit} faili lubatud iga objekti kohta.",
        emailParseLimitReached: "E-kirjade töötlemise limiit on saavutatud. Palun uuendage oma plaani või töötlege käsitsi.",
        emailLimitText: "E-kirjade töötlemise limiit on saavutatud.",
        monthlyEmailScans: "Kuu E-kirjade skaneerimised (Pro)",
        lifetimeEmailScans: "Eluaegsed E-kirjade skaneerimised (Tasuta)",
        monthlyFileScans: "Kuu kviitungite skaneerimine (Pro)",
        lifetimeFileScans: "Eluaegne kviitungite skaneerimine (Tasuta)",
        fileLimitText: "Kviitungite skaneerimise limiit on saavutatud.",
        planFreeTier: "Tasuta plaan",
        planProTier: "Pro plaan",
        uploadFailed: "Üleslaadimine ebaõnnestus",
        attachments: "Manused",
        limitsAndUsage: "Piirangud ja kasutus",
        addresses: "aadressid",
        emailCopied: "E-posti aadress kopeeritud!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Kaasatud",
        proOnly: "Ainult PRO",
        month: "kuu",
        openInNewTab: "Ava uues vahekaardis",
        menu: "Menüü",
        home: "Avaleht",
        monthsShort: {
            0: "jaan",
            1: "veebr",
            2: "märts",
            3: "apr",
            4: "mai",
            5: "juuni",
            6: "juuli",
            7: "aug",
            8: "sept",
            9: "okt",
            10: "nov",
            11: "dets",
        },
    },
    carMetadata: {
        bodyType: "Kere tüüp",
        drivetrain: "Jõuülekanne",
        transmission: "Ülekanne",
        bodyTypes: {
            sedan: "Sedaan",
            hatchback: "Hatchback",
            wagon: "Vagun (Estate)",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupe",
            convertible: "Kabriolet",
            pickup: "Pickup",
            van: "Kaubik / Minikaubik",
            commercial: "Äriline",
            other: "Muu",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "Eesmine",
            rwd: "Tagumine",
            awd: "AWD / 4x4",
            other: "Muu",
        },
        transmissions: {
            not_specified: "-",
            manual: "Manuaal",
            automatic: "Automaatne",
            cvt: "CVT",
            other: "Muu",
        },
        otherLabel: "Muu (täpsusta)",
        mileageLabel: "Kilomeetrid",
    },
    auth: {
        welcome: "Tere tulemast",
        welcomeBack: "Tere tagasi",
        signIn: "Logi sisse",
        signInWithGoogle: "Logi sisse Google'iga",
        signOut: "Logi välja",
        magicLinkDesc: "Saada maagiline link oma e-posti",
        magicLinkSent: "Maagiline link saadetud!",
        magicLinkCheckEmail: "Kontrolli oma e-posti ja kliki lingil, et sisse logida.",
        emailAddress: "E-posti aadress",
        getMagicLink: "Saada maagiline link",
        sending: "Saadan...",
        linkSent: "Link saadetud",
        orContinueWith: "Või jätka",
        googleAccount: "Google'i konto",
        newUserNote: "Uus siin? Teie konto luuakse automaatselt pärast esimest edukat sisselogimist.",
        magicLinkError: "Maagilise lingi saatmine ebaõnnestus. Palun kontrollige oma e-posti ja proovige uuesti.",
        genericError: "Ilmnes viga. Palun proovige uuesti.",
        projectDescription: "Jälgige oma auto kulusid, hooldust ja ajalugu ühes kohas.",
        loginError: "Sisselogimine ebaõnnestus",
        loggingIn: "Sisenemine...",
        authenticating: "Autentimine...",
        authenticatingDesc: "Palun oodake, kuni me teie sessiooni turvame.",
    },
    settings: {
        title: "Seaded",
        systemPreferences: "Süsteemi Eelistused",
        appSettings: "Rakenduse Seaded",
        dangerZone: "Ohtlik Ala",
        theme: "Teema",
        language: "Liidese Keel",
        currency: "Valuuta",
        units: "Ühikute süsteem",
        distanceUnit: "Kauguse Ühik",
        volumeUnit: "Mahutavuse Ühik",
        expenseTypes: "Kulu Tüübid",
        expenseTypesDesc: "Halda kategooriaid",
        categories: "Kategooriad",
        exportData: "Ekspordi Andmed",
        exportDesc: "Laadi alla põhjalik CSV",
        importData: "Impordi Andmed",
        importDesc: "Taasta CSV varukoopiast",
        deleteAccount: "Kustuta Konto",
        deleteAccountDesc: "Kustuta kõik andmed püsivalt",
        enableSync: "Luba Sünkroonimine",
        enableSyncDesc: "Sünkroniseeri andmed seadmete vahel",
        account: "Konto",
        accountPlan: "Konto plaan",
        carsUsage: "Autod",
        carsLimitReached: "Auto limiit on saavutatud",
        storageSize: "Salvestusmaht",
        emailScans: "E-kirjad skaneeringud",
        fileScans: "Kviitungite skaneeringud",
        plans: "Plaanid",
        currentlyPlan: "Praegu",
        upgradePlan: "Uuenda",
        manageSubscription: "Halda tellimust",
        nextPayment: "Järgmine makse",
        endsOn: "Lõpeb",
        adminConsole: "Administraatori Konsool",
        systemControl: "Süsteemi Kontroll",
        customCategories: "Kohandatud Kategooriad ja Sildid",
        interfaceTheme: "Liidese Teema",
        light: "Hele",
        dark: "Tume",
        timezone: "Ajavahe",
        timezoneDesc: "Kasutatakse ajastatud e-kirjade meeldetuletamiseks",
        timeFormat: "Aja formaat",
        timeFormat24h: "24-tunnine (14:30)",
        timeFormat12h: "12-tunnine (2:30 PM)",
        kilometers: "kilomeetrit (km)",
        miles: "miili (mi)",
        liters: "liitrit (l)",
        gallons: "gallonit (gal)",
        accountManagement: "Konto Halduse",
        contactUs: "Võta meiega ühendust",
        contactDesc: "Soovituste, funktsioonide taotluste ja küsimuste jaoks",
        logOut: "Logi välja",
        logOutConfirmTitle: "Logi välja",
        logOutConfirmMessage: "Kas olete kindel, et soovite oma kontolt välja logida?",
        keepAccount: "Hoia Konto",
        deleteAccountConfirmTitle: "Kustuta Konto",
        deleteAccountConfirmMessage: "Kas olete kindel, et soovite oma konto ja kõik seotud auto andmed püsivalt kustutada? Seda toimingut ei saa tagasi võtta.",
        deletePermanently: "Kustuta Püsivalt",
        deleting: "Kustutamine...",
        contactSupport: "Võta ühendust Toega",
        messageSent: "Sõnum saadetud!",
        feedbackThanks: "Aitäh teie tagasiside eest. Hindame teie panust ja vaatame selle üle.",
        backToSettings: "Tagasi seadete juurde",
        subjectLabel: "Teema",
        messageLabel: "Sõnum",
        subjectPlaceholder: "Mis see on?",
        messagePlaceholder: "Rääkige meile oma soovitusest, funktsioonide taotlusest või küsimusest...",
        enterSubjectAlert: "Palun sisestage teema",
        enterMessageAlert: "Palun sisestage sõnum",
        sendFailedAlert: "Sõnumi saatmine ebaõnnestus. Palun proovige hiljem uuesti.",
    },
    export: {
        title: "Ekspordi Andmed",
        generatePDF: "Genereeri PDF",
        carInformation: "Auto Teave",
        editInfo: "Muuda allolevat teavet, et kohandada oma eksporti",
        editInfoHint: "Saate eemaldada või muuta kõiki välju, mida te ei soovi lisada",
        filters: "Filtrid",
        expenseTypes: "Kulutuste Tüübid",
        includeNotes: "Sisalda Märkmeid",
        includeImages: "Sisalda Pilte ja Faile",
        hideDisabled: "Peida Keelatud Esemed",
        itemsCount: "{total} eset, {selected} valitud",
        selectAll: "Vali Kõik",
        deselectAll: "Tühista Kõik",
        expenses: "Kulud",
        notes: "Märkmed",
        spareParts: "Varuosad",
        images: "Pildid",
        files: "Failid",
        summary: "Kokkuvõte",
        totalExpenses: "Kokku Kulud",
        totalItems: "Kokku Esemed",
        generatedOn: "Genereeritud",
        noItemsSelected: "Eksportimiseks ei ole valitud ühtegi eset",
        noItemsAvailable: "Eksportimiseks ei ole ühtegi eset saadaval",
        generating: "PDF-i genereerimine...",
        downloadPDF: "Laadi alla PDF",
        pdfFileName: "{carName}_eksport_{date}.pdf",
        reportTitle: "Auto kulude aruanne",
        exportButton: "Eksporti",
        generateCSV: "Genereeri CSV",
        formatSelectorTitle: "Vali vorming",
        formatSelectorMsg: "Palun vali ekspordivorming",
        proFeatureExportTitle: "Pro funktsioon: andmete eksport",
        proFeatureExportDesc: "Uuendage PRO versioonile, et eksportida oma auto ajalugu PDF formaati.",
        exportRestrictedPopup: "Andmete eksport on saadaval ainult Pro kasutajatele.",
        allTypes: "Kõik Tüübid",
        statistics: "Statistika",
        driven: "Sõidetud",
        since: "Alates",
        averageCost: "Keskmine Kulu",
        perKm: "km kohta",
        perMile: "miili kohta",
        period: "Periood",
        dateFrom: "Alates",
        dateTo: "Kuni",
        allTime: "Kustuta filter",
        periodHint: "Kui perioodi ei ole valitud — kuvatakse kõik kulud",
        noExpenses: "Filtritega ei ühti ühtegi kulu",
        expensesSection: "Kulud",
        attachmentsSection: "Manused",
        imagesCount: "{count} pilti",
        pdfsCount: "{count} PDF-i",
        includeParts: "Sisalda varuosi",
        pageLabel: "Leht",
    },
    expenses: {
        title: "Kulud",
        newExpense: "Uus Kulu",
        editExpense: "Muuda Kulu",
        openExpense: "Ava kulude sisestus",
        details: "Kulude Üksikasjad",
        selectType: "Vali Tüüp",
        selectTypePlaceholder: "Vali kulutüübi...",
        shortDescriptionPlaceholder: "Lühike kirjeldus...",
        expenseTitle: "Pealkiri",
        logEntryTitleLabel: "Kirje pealkiri (valikuline)",
        defaultTitlePlaceholder: "Vaikimisi - {type}",
        autoTitlePlaceholder: "Täidetakse automaatselt valitud tüüpide põhjal",
        carDataTitle: "Auto andmed",
        defaultTitlePrefix: "Vaikimisi pealkiri on -",
        addAnother: "Lisa muud tüüpi kulu",
        addAnotherHint: "Kui see kirje sisaldab mitut tüüpi kulusid, saate need kõik siia lisada, et tagada täpne statistika.",
        carValueDescription: "Auto hinnanguline turuväärtus sel hetkel.",
        type: "Tüüp",
        date: "Kuupäev",
        amount: "Summa",
        totalAmount: "Kokku",
        splitCosts: "Jagada kulusid?",
        combineCosts: "Kombineeri kulud",
        amountWork: "Töö summa",
        amountParts: "Osade summa",
        mileage: "Kilomeetrid",
        carValue: "Auto Väärtus",
        description: "Kirjeldus",
        detailedDescription: "Üksikasjalik kirjeldus",
        electricity: "Elekter",
        fuelType: "Kütuse Tüüp",
        fuelTypeOptions: {
            petrol: "Bensiin",
            diesel: "Diisel",
            lpg: "LPG",
            electricity: "Elekter",
        },
        carData: "Auto Andmed",
        images: "Pildid ja Failid",
        addImages: "Lisa Pilte ja Faile",
        addImagesPDFs: "Lisa Pilte või PDF-e",
        deleteExpense: "Kustuta Kulu",
        deleteConfirm: "Kas olete kindel, et soovite selle kulu kustutada?",
        saveSuccess: "Kulu salvestatud edukalt",
        thisExpense: "See kulu",
        stats: {
            annual: "Aastane",
            allTime: "Kogu Aeg",
            avgMonth: "Keskmine/Kuu",
            costPer: "Kulu/",
            noExpenses: "Kulusid pole veel",
            dragToReorder: "Lohe käepidet, et ümber korraldada",
        },
        expensesFound: "Loodud",
        noExpensesFound: "Kulusid ei leitud.",
        noDescription: "Kirjeldust pole",
        imagesCount: "Pildid ({count})",
        deleteImageTitle: "Kustuta Pilt",
        deleteImageConfirm: "Kas olete kindel, et soovite selle pildi kustutada? Seda toimingut ei saa tagasi võtta.",
        typeLabels: {
            fuel: "Kütus",
            car_wash: "Pesemine",
            repairs: "Remont",
            maintenance: "Hooldus",
            parts: "Varuosad",
            insurance: "Kindlustus",
            inspection: "Tehniline Kontroll",
            tyres: "Rehvid",
            parking: "Parkimine",
            electricity: "Elekter",
            taxes: "Maksud",
            other: "Muu",
            info: "Teave",
            service_maintenance: "Hooldus",
            service_repair: "Remont",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Hooldus",
            selectSubtype: "Valige tüüp",
            maintenance: "Hooldus",
            repair: "Remont",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Korduv kulu",
        repeatToggle: "Korda seda kulu",
        repeatFrequency: "Sagedus",
        monthly: "Kuu",
        startDate: "Alguskuupäev",
        nextDate: "Järgmine kande kuupäev genereeritakse",
        endDate: "Lõppkuupäev",
        noEndDate: "Ilma lõppkuupäevata",
        copyOptions: "Kopeeri valikud",
        copyTitle: "Kopeeri kirje pealkiri",
        copyLocation: "Kopeeri asukoht",
        copyDescription: "Kopeeri kirjeldus",
        active: "Aktiivne",
        status: "Olek",
        managedByRepeat: "See kulu on osa korduvast järjestusest.",
        placeholder: "Siin saad seadistada automaatset kordust selle kulu jaoks, kui see toimub regulaarselt sama summa ulatuses.",
        deleteRepeat: "Kustuta kordus",
        deleteRepeatConfirm: "Kas oled kindel, et soovid selle korduva järjestuse peatada ja kustutada? Tulevasi kandeid ei genereerita. Minevikukanded jäävad alles.",
        relatedEntries: "Selle järjestuse kanded",
        stopRepeat: "Peata kordamine",
        isRepeating: "Korduv",
        noTerm: "Määramata ajaks",
        until: "Viimane kande kuupäev genereeritakse",
        summaryCopy: "Süsteem kopeerib",
        simulate: "Simuleeri järgmise kirje genereerimist",
        simulateSuccess: "Järgmise kirje genereerimine simuleeritud edukalt",
        simulateNoDate: "Rohkem kuupäevi genereerimiseks pole (lõppkuupäev saavutatud)",
    },
    onboarding: {
        title: "Profiili Seadistamine",
        welcome: "Tere tulemast!",
        subtitle: "Kohanda oma sõidukogemust.",
        currency: "Valuuta",
        preferredCurrency: "Eelistatud Valuuta",
        distUnit: "Kauguse Ühik",
        volUnit: "Mahutavuse Ühik",
        complete: "Seadistamine Lõpetatud",
    },
    cars: {
        unitChangeWarningTitle: "Ühikute muutmise hoiatus",
        unitChangeWarningMessage: "Nende üksuste muutmine ei muuda teie olemasolevaid andmeid. Kõik ajaloolised kirjed jäävad täpselt selliseks, nagu need on sisestatud.",
        unitChangeWarningConfirm: "Mõistetud",
        title: "Garaaž",
        carAdmins: "Auto administraatorid",
        sharedWithMe: "Jagatud minuga",
        manageAdmins: "Halda administraatoreid",
        adminEmail: "Administraatori e-post",
        addAdmin: "Lisa administraator",
        addAdminPlaceholder: "nt. sõber@email.com",
        removeAdmin: "Eemalda",
        removeAdminConfirm: "Kas olete kindel, et soovite selle administraatori eemaldada?",
        adminAdded: "Administraator lisatud",
        adminRemoved: "Administraator eemaldatud",
        removeMyAccess: "Eemalda minu juurdepääs",
        removeMyAccessConfirm: "Kas olete kindel, et soovite sellest autost juurdepääsu loobuda?",
        myAccessRemoved: "Juurdepääs eemaldatud",
        noAdminsYet: "Ühtegi administraatorit pole veel lisatud.",
        adminInfoText: "Administraatorid saavad lisada ja redigeerida kulusid, märkmeid ja varuosi, kuid ei saa autot ise kustutada.",
        newCar: "Lisa Auto",
        carNotFound: "Auto ei leitud",
        carNotFoundDesc: "Taotletud autot ei eksisteeri või teil ei ole sellele juurdepääsu.",
        accessDenied: "Juurdepääs keelatud",
        accessDeniedDesc: "See auto on privaatne ja mitte avalikult saadaval.",
        backToHome: "Tagasi avalehele",
        adminRestricted: "Juurdepääs piiratud",
        adminRestrictedDesc: "Ainult volitatud administraatoritel on juurdepääs sellele konsoolile. Palun naaske peamise rakenduse juurde.",
        returnHome: "Naase kodu",
        editCar: "Muuda Autot",
        name: "Auto Nimi",
        model: "Mudel",
        year: "Aasta",
        plate: "Numbrimärk",
        vin: "VIN number",
        mileage: "Praegune läbisõit",
        initialMileage: "Esialgne läbisõit",
        engineType: "Mootori tüüp",
        tapToChangeIcon: "Puuduta, et ikooni muuta",
        chooseIcon: "Vali ikoon",
        imageTab: "Pilt",
        iconTab: "Ikoon",
        chooseColor: "Vali värv",
        chooseEmoji: "Vali emoji",
        uploadImage: "Laadi üles pilt",
        clickToBrowse: "Kliki, et sirvida faile",
        currentCarIcon: "Praegune auto ikoon",
        changeImage: "Muuda pilti",
        zoom: "Suurenda",
        rotate: "Pööra",
        removeChangeImage: "Eemalda / Muuda pilti",
        selectIcon: "Vali ikoon",
        cropAndSave: "Lõika ja salvesta",
        displayName: "Kuvamise nimi",
        displayNamePlaceholder: "nt. Minu nädalavahetuse auto",
        makeLabel: "Mark *",
        modelLabel: "Mudel *",
        yearLabel: "Aasta *",
        fuelTypeLabel: "Kütuse tüüp *",
        licensePlateLabel: "Registreerimisnumber",
        vinLabel: "VIN",
        notesLabel: "Märkmed (valikuline)",
        notesPlaceholder: "nt 1.6 TDI, 85kW, 1588cc, aku 62kWh, AWD jne.",
        publicAccess: "Muuda auto avalikult ligipääsetavaks",
        publicAccessDesc: "Teised saavad seda autot vaadata jagatud lingi kaudu",
        shareLocations: "Luba ka lisatud asukohtade vaatamine",
        shareLocationsDesc: "Aktiveeri see, et auto asukohad oleksid avalikus vaates nähtavad",
        deleteCar: "Kustuta auto",
        deleteCarTitle: "Kustuta auto",
        deleteCarConfirm: "Kas oled kindel, et soovid kustutada '{name}'? Seda toimingut ei saa tagasi võtta.",
        noCars: "Sinu garaažis pole autosid",
        addFirstCarNote: "Alusta oma teekonda, lisades oma esimese sõiduki kulude jälgimiseks.",
        addVehicle: "Lisa sõiduk",
        myVehicles: "Minu sõidukid",
        favorites: "Lemmikud",
        deleteConfirm: "Kas oled kindel, et soovid selle auto kustutada? Kõik seotud kulud kustutatakse.",
        deleteFailed: "Auto kustutamine ebaõnnestus",
        saveFailed: "Auto andmete salvestamine ebaõnnestus",
        adminActions: "Admini toimingud",
        importCsv: "Impordi CSV",
        clearData: "Kustuta andmed",
        distanceUnitLabel: "Kauguse ühik",
        volumeUnitLabel: "Mahutavuse ühik",
        currencyLabel: "Valuuta",
        boughtAt: "Ostukuupäev",
        purchasePrice: "Ostuhind",
        purchaseMileage: "Ostuläbisõit",
        createPurchaseRecord: "Loo ostuajalugu automaatselt",
        makePlaceholder: "nt. BMW",
        modelPlaceholder: "nt. X5",
        platePlaceholder: "nt. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "See teave loob sinu ajaloos esialgse 'Teabe' kirje määratud andmetega.",
        availableTypes: "Saadaval tüübid",
        dragToReorder: "Loobu ümber korraldama",
        requestTypeNote: "Kui vajad muud tüüpi - ",
        requestTypeAction: "anna teada!",
        emailProcessingTitle: "E-kirjade töötlemine",
        emailInstructions: "Edasta oma kviitungid allolevale aadressile. Me ekstraktime andmed ja loome kulud automaatselt.",
        recentEmails: "Saadetud e-kirjad",
        viewAllEmails: "Kuva kõik ({count})",
        noEmailsReceived: "E-kirju pole veel saadetud.",
        analysisResult: "Analüüsi tulemus",
        vehicleInfo: "Sõiduki teave",
        preferences: "Eelistused",
        purchaseHistory: "Ostu ajalugu",
        emailProcessing: "E-kirjade töötlemine",
        publicAccessTitle: "Avalik ligipääs",
        expenseTypesTitle: "Kulu tüübid",
        adminActionsTitle: "Admini toimingud",
        enterPurchaseDateAlert: "Palun sisesta ostukuupäev",
        allowedSenderEmails: "Lubatud saatja e-postid",
        allowedEmailsDesc: "Lisage e-posti aadresse, mis on lubatud selle autoga kviitungite saatmiseks. Maksimaalselt 5 aadressi.",
        noAllowedEmails: "Ühtegi lubatud e-posti aadressi pole lisatud.",
        emailAlreadyAdded: "See e-post on juba selle auto jaoks lubatud.",
        maxAllowedEmailsReached: "Lubatud e-posti aadresside maksimaalne piirang on saavutatud.",
        addAllowedEmailPlaceholder: "Lisa lubatud e-post...",
        ownerEmail: "Omanik",
        onlyOwner: "ainult omanik",
        defaultAllowed: "Alati lubatud",
        carLimitReachedTitle: "Auto limiit on saavutatud",
        carLimitReachedMessage: "Teie {plan} plaan lubab {limit} autot. Teil on juba {current}. Minge seadistustesse, et näha oma limite või võtke meiega ühendust, et uuendada.",
        carLimitGoToSettings: "Mine seadistustesse",
        archivedCars: "Arhiivitud",
        archiveCar: "Arhiivida auto",
        unarchiveCar: "Eemalda arhiivist auto",
        sellDate: "Müügi kuupäev",
        sellPrice: "Müügi hind",
        sellMileage: "Müügi läbisõit",
        archiveConfirm: "Kas olete kindel, et soovite selle auto arhiivida?",
        archiveInstructions: "Auto arhiivimine tähendab, et see ei ole enam teie oma või te ei hoolda seda enam. Palun esitage müügiga seotud andmed statistika jaoks. See muudab auto ainult lugemiseks.",
        archivedBadge: "Arhiivitud",
        saleDetails: "Müügi üksikasjad",
        saleDetailsNote: "Müügi üksikasju kasutatakse statistika jaoks. Saate neid vajadusel uuendada.",
        archiveDetailsNotFillable: "Palun täitke kõik väljad, et arhiivida auto",
        emailAddressWillBeAvailableAfterSave: "E-posti aadress on saadaval pärast auto salvestamist.",
        proFeatureAdminTitle: "Pro funktsioon: Auto administraatorid",
        proFeatureAdminDesc: "Lisage teised kasutajad, kes saavad seda auto andmeid vaadata ja hallata.",
        proFeatureEmailTitle: "Pro funktsioon: Lisasaajad",
        proFeatureEmailDesc: "Lisage teised lubatud e-posti aadressid, millelt kviitungid sellele autole saadetakse.",
        estimatedMileage: "Hinnanguline läbisõit",
        summaryFrequencyLabel: "Kokkuvõtte sagedus",
        summaryFrequencyOptions: {
            none: "Väljas",
            monthly: "Kuu",
            semiAnnually: "Poolaasta",
            annually: "Aasta",
        },
        healthProfilePrompt: "Täida oma terviseprofiil täpse analüüsi jaoks!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Bensiin",
        diesel: "Diisel",
        hybrid: "Hübriid",
        electric: "Elektriline",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Läbisõidu trend",
        title: "Statistika",
        allYears: "Kõik aastad",
        totalSpent: "Kokku kulutatud",
        spentIn: "Kulutatud aastal {year}",
        perMonth: "kuus",
        overall: "kokku",
        vsPrev12m: "vs eelmine 12k",
        rolling12m: "Viimased 12k",
        byType: "Tüübi järgi",
        byMonth: "Kuu järgi",
        byYear: "Aasta järgi",
        noData: "Selle aasta kohta pole andmeid",
        mostExpensive: "Kalleim",
        top: "Parim",
        untitled: "Pealkirjata",
        assetAnalysis: "Varade väärtuse ja kulude analüüs",
        burnNote: "* 'Kokku põletamine' sisaldab nii kulutatud raha kui ka hinnangulist vähenemist auto väärtuses.",
        carMarketValue: "Auto turuväärtus",
        cumulativeCosts: "Kumulatiivsed kulud",
        totalBurn: "Kokku põletamine (kulud + amort)",
        entries: "kanded",
        avgPrice: "Keskmine hind",
        consumption: "Kütusekulu",
        price: "Hind",
        fuelPriceTrend: "Kütusehinna trend",
        spendingTrend: "Kulutuste suundumus",
        costPerKmTrend: "Kulud 1 km kohta",
        costPerMileTrend: "Kulud 1 miili kohta",
        serviceTrendsTitle: "Teenuste Trendid",
        expensesOnMap: "Kulud kaardil",
        visitsCountLabel: "külastust",
        locationsSummary: "Asukohtade kokkuvõte",
        locationsCountLabel: "kohta",
        noLocationsFoundTitle: "Asukohti ei leitud",
        noLocationsFoundDesc: "Lisage asukohti oma kirjetesse, et näha neid kaardil.",
        addMileageData: "Lisa läbisõit",
        missingMileageInfo: "Ei ole piisavalt andmeid, et arvutada kulu kauguse kohta. Lisage vähemalt 2 läbisõidu näitu selle perioodi jooksul (või üks enne seda perioodi).",
        mileageModal: {
            title: "Lisa puuduv läbisõit",
            description: "Kuna {year} kulude täpseks arvutamiseks peame teadma läbisõitu aasta alguses ja lõpus.",
            startOfYear: "Aasta algus (1. jaanuar)",
            endOfYear: "Aasta lõpp (31. detsember)",
            currentMileage: "Praegune läbisõit",
            placeholder: "Sisestage läbisõit...",
            save: "Salvesta andmed",
            foundNearby: "Leitud lähedalt ({date}): {value} {unit}",
            useExisting: "Kasutage seda",
        },
        proAnalysis: "Pro analüüs",
        detailedAnalysis: "Detailne analüüs",
        upgradeToSee: "Uuendage, et näha →",
    },
    tabs: {
        dashboard: "Armatuurlaud",
        expenses: "Kulud",
        stats: "Statistika",
        locations: "Asukohad",
        gallery: "Gallery",
        parts: "Osad",
        notes: "Märkmed",
        repair: "Remondi režiim",
        'repair-switch': "Auto vahetus",
    },
    repairAnalysis: {
        title: "Remondiotsuse analüüs",
        ownershipLength: "Omandi kestus",
        currentValue: "Praegune väärtus",
        valueOutdated: "Väärtus võib olla aegunud",
        addValueToEnable: "Lisa praegune auto väärtus analüüsi lubamiseks",
        totalInvested: "Kokku investeeritud",
        totalInvestedSub: "Ostuhind + remondid",
        totalExcludesFuel: "ei sisalda kütust / elektrit",
        fuelLabelFuelOnly: "Kütuse kogusumma",
        fuelLabelEnergyOnly: "Energia kogusumma",
        fuelLabelHybrid: "Kütuse ja energia kogusumma",
        fuelTypeFuel: "kütus",
        fuelTypeEnergy: "elektri",
        fuelTypeHybrid: "kütus ja elekter",
        fuelTotalLabel: "Kütuse/Energia kokku:",
        projectionMode: "Prognoosimise režiim",
        projectionModes: {
            lastYear: "Eelmise aasta põhjal",
            average: "Ajalooline keskmine",
            trend: "Trend (lineaarne)",
        },
        brakeAssumption: "Hooldus sisaldab hinnangulist 3-aastast piduritsüklit",
        repairBuffer: "Sisaldab vanuse põhjal remondiriskide pufferit",
        yearLabel: "aasta",
        totalInvestedDesc: "Ostuhind + kõik remondid",
        repairToValue: "Remont väärtusele (12 kuud)",
        repairToValueExplain: "Remont €{cost} vs auto väärtus €{value}. Alla 20% on tervislik; üle 50% on kõrge risk.",
        ownershipPressure: "Omandi surve",
        ownershipPressureExplain: "Kokkuvõttes kulud: remondid €{cost} + väärtuse langus vs €{value}. Üle 35% näitab rahalist stressi.",
        investmentGap: "Investeeringute vahe",
        investmentGapExplain: "Kokku investeeritud €{invested} miinus praegune väärtus €{value}. See näitab, kui palju olete omandist 'kaotanud' seni.",
        investmentGapDesc: "Kokku investeeritud - praegune väärtus",
        repairExpenses12m: "12 kuu remondikulud",
        calculatedYearlyMileage: "Arvutatud aastane läbisõit: {km} km",
        calculatedYearlyRepairs: "Arvutatud aastased remondikulud: {amount}",
        set: "Seadista",
        plannedRepairCost: "Planeeritud remondikulu",
        whatIfTitle: "Mis juhtub, kui kulutad {amount} nüüd?",
        updatedScore: "Uuendatud skoor",
        updatedVerdict: "Uuendatud otsus",
        howIsItCalculated: "Kuidas see arvutatakse?",
        usedLifespan: "Kasutatud: {usage}% oodatud eluiga",
        remainingLifespan: "Jäänud: ~{km} km",
        estimatedLifespan: "Hinnanguline eluiga: {km} km",
        lifecycle_stage_early: "Varane elutsükkel – madal suurte rikete risk",
        lifecycle_stage_mid: "Keskmine elutsükkel – normaalne kulumine",
        lifecycle_stage_late: "Hiline elutsükkel – suurenenud remondirisk",
        lifecycle_stage_end: "Oodatud eluea lõpp – kõrge suurte remondikulude risk",
        calculationExplanation: "Analüüs kasutab teie sõiduki ostuhinda, hiljutisi remondikulusid ja hinnangulist praegust väärtust, et arvutada finantsilise heaolu skoor. Suured remondikulud võrreldes auto väärtusega või kiire depretsioon alandavad skoori.",
        confidenceLabel: "Usaldusväärsus",
        confidenceLevel: {
            high: "Kõrge",
            medium: "Keskmine",
            low: "Madala",
        },
        mentalFactorsTitle: "Paranda täpsust oma kogemustega",
        mentalFactorsCTA: "Kiire kontroll (30 sek)",
        mentalFactorsSurveyTitle: "Teie Kogemus",
        mentalFactorsSurveyDesc: "Vastake 3 kiirele küsimusele, et isikupärastada oma skoori.",
        q1: "Kas teie auto vastab teie vajadustele?",
        q1Help: "Ruum, mugavus, funktsioonid",
        q2: "Kas teile meeldib oma autoga sõita?",
        q2Help: "Visuaal, mugavus, tunne",
        q3: "Kas te muretsete ootamatute rikete pärast?",
        q3Help: "Usaldusväärsuse mured",
        q4: "Kas see auto on mõeldud pere ja pikkadeks reisideks?",
        q4Help: "Ohutus ja usaldusväärsus on prioriteet",
        factorsTitle: "Skoori Tegurid",
        factorsDesc: "Vaadake, mis mõjutab teie skoori",
        newCarComparison: "Uue Auto Võrdlus",
        newCarComparisonDesc: "Võrdle oma praegust igakuist kulu uue auto ostmisega.",
        modeLeasing: "Liising",
        modeFullPrice: "Täishind",
        downPayment: "Esimene sissemakse",
        leaseYears: "Periood (aastad)",
        monthlyPayment: "Igakuine makse",
        carPrice: "Auto täishind",
        ownershipYears: "Planeeritud omamine (aastad)",
        insuranceMonthly: "Igakuine CASCO / Kindlustus",
        currentMonthlyCost: "Praegune auto kulu",
        newCarMonthlyCost: "Uue auto kulu",
        newCarCheaper: "Uus auto on odavam: {amount} / kuu",
        newCarMoreExpensive: "Uus auto on kallim: {amount} / kuu",
        newCarSameCost: "Kulud on täpselt samad.",
        advancedSettings: "Täiendavad seaded",
        yearlyMaint: "Aastane hooldus (€)",
        tyres3Yrs: "Rehvid / 3a (€)",
        depreciation5Yrs: "Amortisatsioon (5 a %)",
        newCarYear: "Uue auto aasta",
        cumulativeCosts: "Kumulatiivsed kulud (prognoos)",
        comparisonByYear: "Võrdlus aastate lõikes",
        currentCarLabel: "Praegune auto",
        newCarLabel: "Uus auto",
        resaleValue: "Taaskasutusväärtus",
        startupCosts: "Algkulud (kasutatud auto)",
        inspection: "Eelkontroll",
        initialMaintenance: "Esialgne hooldus + õlid",
        registration: "Registreerimine / Tasud",
        total: "Kokku",
        currentCarTitle: "Praegune auto",
        newCarTitle: "Potentsiaalne auto",
        upfrontInvestment: "Eesmine investeering",
        monthlyReality: "Reaalne kuukulu",
        depreciationShort: "Amortisatsioon",
        howCalculated: "Kuidas see arvutatakse?",
        deltaMonthly: "Kuu erinevus",
        deltaUpfront: "Eesmine erinevus",
        surveyMeanings: {
            practical: {
                1: "Üldse mitte",
                2: "Halb sobivus",
                3: "Keskmine",
                4: "Hea sobivus",
                5: "Täiuslik sobivus",
            },
            joy: {
                1: "Pettumust valmistav",
                2: "Igav",
                3: "Keskmine",
                4: "Nauditav",
                5: "Väga palju",
            },
            worry: {
                1: "Ei muretse",
                2: "Veidi mures",
                3: "Mures",
                4: "Väga mures",
                5: "Kindel, et puruneb igal hetkel",
            },
        },
        verdicts: {
            KEEP: "Finantsiliselt mõistlik hoida",
            borderline: "Piiril – jälgige hoolikalt",
            sell: "Suure finantsriskiga – müük võib olla mõistlik",
        },
        factors: {
            trendInc: "Kasvav trend",
            trendIncDesc: "Remondikulud kasvavad võrreldes eelmise aastaga.",
            lowDepreciation: "Madala amortisatsiooni eelis",
            lowDepreciationDesc: "Vanemad/odavamad autod kaotavad aja jooksul vähem väärtust.",
            stableRepairs: "Stabiilsed remondikulud",
            stableRepairsDesc: "Teie remondikulud on stabiilsed või vähenevad.",
            noHistoricalData: "Ei ole andmeid, mis on vanemad kui 6 kuud.",
            lifecycle_stage: "Sõiduki elutsükli etapp",
            high_risk_phase: "Kõrge riski faas",
            high_risk_phase_desc: "Hilises elutsükli etapis ja kasvavad remondikulud näitavad suurt riski.",
            lowCostKm: "Tõhus kulu km kohta",
            lowCostKmDesc: "Selle auto käitamise üldine efektiivsus on suurepärane.",
            lowFixedCosts: "Madalaid fikseeritud kulusid",
            lowFixedCostsDesc: "Teie fikseeritud kulud (maksud, kindlustus) on madalad.",
            usage: "Aastane kasutus",
            usageDesc: "Möödunud 12 kuu jooksul sõidetud vahemaa.",
            accidentMinor: "Kerge õnnetus",
            accidentMinorDesc: "Kosmeetilised kahjustused või väikesed remondid.",
            structuralDamage: "Struktuurne kahjustus",
            structuralDamageDesc: "Raami või struktuurilised probleemid vähendavad väärtust drastiliselt.",
            aiLifespanNearEnd: "Oodatava eluea lõpp",
            aiLifespanAging: "Vananevad komponendid",
            aiLifespanGood: "Madala läbisõidu eelis",
            aiLifespanDesc: "Põhineb AI hinnangulise tüüpilise eluea selle mudeli jaoks.",
            aiUpcomingRepairs: "Tulevased remondid (AI prognoos)",
            aiUpcomingRepairsDesc: "AI prognoosib peamiste komponentide rikkeid peagi läbisõidu põhjal.",
            ownershipFatigue: "Omandi väsimus",
            ownershipFatigueLong: "Pikaajaline omamine viib sageli vaimsesse valmisolekusse teise sõiduki jaoks.",
            ownershipFatigueShort: "Esialgne omandi eelarve loob tugevama kalduvuse autot hoida.",
            family_priority: "Pere & Pikkad Reisid",
            replacement_comparison: "Asendamise Võrdlus",
            none: "Puudub",
            surface: "Pind",
            minor: "Mõõdukas",
            moderate: "Mõõdukas",
            severe: "Tõsine",
            structural: "Struktuurne",
            major: "Oluline",
            critical: "Kriitiline",
            full: "Täielik",
            improveLabel: "Mis parandaks seda:",
            info_original_price: "Umbes selle auto hind, kui see oli uus. Aitab hinnata väärtuse stabiilsust. Vanemad autod, mille jääkväärtus on madalam, on rahaliselt turvalisemad.",
            info_current_value: "Kui palju saaksid selle täna müüa. Kasutatakse, et kontrollida, kas remondikulud on auto väärtusest suur protsent, mis viitab halvale investeeringule.",
            info_yearly_mileage: "Suurem läbisõit suurendab kulumist. Madal läbisõit võib oluliselt pikendada auto eluiga.",
            info_estimated_repairs: "Jätkuv kulu auto töös hoidmiseks. Suured aastased kulud vähendavad auto hoidmise atraktiivsust.",
            info_planned_repairs: "Teadaolevad tulevased remondid. Simuleerib kohest survet sinu otsusele.",
            info_ownership_years: "Kui kaua oled seda autot omanud? See mõjutab psühholoogilist omandi väsimust ja esialgset ostja eelarvet.",
            info_rust: "Kriitiline pikaajaline risk. Struktuurne rooste vähendab ohutust. Tõsine rooste muudab müügi paremaks valikuks.",
            info_crashes: "Struktuursed õnnetused mõjutavad ohutust ja usaldusväärsust. Need vähendavad ka taaskasutusväärtust oluliselt.",
            info_repaint: "Viitab varasemale kahjustusele või kosmeetilistele parandustele. Väike mõju, välja arvatud juhul, kui sügavamad probleemid olid varjatud.",
            info_unresolved: "Peidetud tulevased kulud. Teadaolevad vead elektroonikas, mootoris või hoolduses, mis vajavad tähelepanu.",
            info_fit: "Kas auto sobib sinu vajadustele (ruum, mugavus)? Halb sobivus tähendab, et oled tõenäolisemalt valmis selle välja vahetama.",
            info_joy: "Emotsionaalne väärtus on oluline. Kui rõõmu pole, siis oled vaimselt valmis uue auto jaoks.",
            info_worry: "Tajutav usaldusväärsuse stress. Suur mure on tugev signaal auto vahetamiseks.",
        },
        explanations: {
            repairFreq: "Teie autol oli {visits} teeninduskülastust viimase 12 kuu jooksul. Sage külastamine näitab madalamat usaldusväärsust ja suuremat vaeva.",
            repairVsValue: "Viimase 12 kuu jooksul maksid teie remondid €{cost}, samas kui auto hinnanguline väärtus on €{value}. See on {ratio}% auto koguväärtusest.",
            stableRepairsDetailYearly: "Eelmisel aastal kulutasite remondile €{cost1}, aga aasta enne seda €{cost2}. Muutus {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "Viimase 6 kuu jooksul kulutasite €{cost1}, eelneva 6 kuu jooksul €{cost2}. Muutus {percent}% ({trend}).",
            mileage: "Läbisõidul {mileage} km siseneb auto suurema osa rikke riskitsooni (ülekande, mootori komponendid).",
            planned: "Teil on planeeritud remondiks €{cost}, mis vähendab kohe auto hoidmise finantsilist ohutust.",
            lowDep: "Autod, mille väärtus on umbes €{value}, kaotavad aastas väga vähe väärtust, tasakaalustades kõrgema remondikulu.",
            depRisk: "Teie auto on {age} aastat vana ja on peaaegu lõpetanud oma amortisatsioonitsükli, mis tähendab, et te ei kaota raha selle väärtuse langemisel.",
            stable: "Sellel aastal kulutasite €{costThisYear} võrreldes €{costLastYear} eelmisel aastal, mis on {percent}% vähenemine. Ennustatavad kulud on matemaatiliselt soodsad.",
            costKm: "Sõitsite eelmisel aastal {km} km. Käituskulud olid €{costKm} kilomeetri kohta, mis näitab suurepärast majanduslikku efektiivsust.",
            fixedCosts: "Maksisite €{costs} fikseeritud aastakulusid (kindlustus/maks). See madal jalajälg annab lisarahu.",
            usage: "Te sõidate umbes {km} km aastas, tuginedes teie logidele.",
            practical_fit: "Hindasite praktilise sobivuse {score}/5, muutes matemaatilist skoori {impact} punkti võrra.",
            emotional_satisfaction: "Hindasite oma emotsionaalset rahulolu {score}/5, muutes skoori {impact} punkti võrra.",
            reliability_anxiety: "Teie usaldusväärsuse usaldus on {score}/5, mõjutades skoori {impact} punkti võrra.",
            rust: "Tõsine struktuurne või aluskere rooste tähendab tavaliselt ohutusprobleeme või mahakandmise stsenaariume.",
            accident: "Eelnevad kahjustused, sõltuvalt tõsidusest, vähendavad auto edasimüügiväärtust ja ohutust.",
            structural: "Struktuursed probleemid muudavad auto automaatselt finantsiliselt ohtlikuks.",
            ai_lifespan: "Läbisõidul {current} km on auto lõpetanud {ratio}% oma AI hinnangulisest elueast ({expect} km).",
            ai_repairs: "AI andmed näitavad, et {count} tüüpilist mudeli spetsiifilist suurt remonti kipuvad toimuma selle läbisõidu juures.",
            lifecycle_stage: "Mida tähendab eluea pikkus? {total} km – see on AI prognoositud punkt, mil suured struktuursed remondid (mootor, käigukast jne) tavaliselt algavad selle mudeli puhul. See ei tähenda auto elu lõppu – auto võib endiselt sõita, kuid oluliselt kõrgemate hoolduskuludega. Tüüpilise auto täis füüsiline eluiga on 500k–1M km, kuid see muutub majanduslikult tasuvaks palju varem.",
        },
        ratios: {
            healthy: "Terve",
            monitor: "Jälgige",
            highRisk: "Kõrge risk",
            stable: "Stabiilne",
            warning: "Hoiatus",
            financialStress: "Finantsstress",
        },
        proFeatureTitle: "Pro funktsioon: Remondirežiim",
        proFeatureDesc: "Avage otsustusmootor, et saada professionaalne finantsanalüüs teie sõiduki remondist. Tasuta kasutajad näevad näidandmeid demonstreerimist.",
        viewDemo: "Vaata reaalset demonstreerimist",
        upgradeToUnlock: "Uuendage PRO-ks, et analüüsida oma autot",
    },
    carTasks: {
        title: "Auto Ülesanded",
        placeholderTitle: "Hoolduse Jälgimine",
        placeholderDesc: "Hooldusplaan teie auto mudeli jaoks.",
        demoTitle: "Auto Hooldusülesanded",
        demoSubtitle: "Nutikas jälgimine teie sõiduki jaoks",
        feature1Title: "Automatiseeritud Ülesannete Loomine",
        feature1Desc: "Loomulikult genereerib ülesandeid nagu õlivahetused, filtri vahetused ja ajastiku rihma kontrollid teie auto mudeli põhjal.",
        feature2Title: "Kulude Integreerimine",
        feature2Desc: "Analüüsib teie teenuse ajalugu, et mõista, mis on juba tehtud ja millal.",
        feature3Title: "Nutikaid Meeldetuletusi",
        feature3Desc: "Saate teateid nii aja kui ka läbisõidu põhjal. Jälgimine lähtestatakse automaatselt, kui märkate ülesande lõpetatuks.",
        getStarted: "Alustamiseks",
        fakeDoorPopupTitle: "Tagasiside Tere Tulemast",
        fakeDoorPopupMessage: "Me arendame hetkel auto hooldusülesandeid. See funktsioon võimaldab teil jälgida teenindusintervalle automaatselt. Milliseid konkreetseid ülesandeid või funktsioone sooviksite kõige rohkem näha?",
        fakeDoorPopupPlaceholder: "Teie mõtted...",
        noTasksYet: "Ülesandeid pole veel",
        deleteAllTitle: "Kustutada ülesannete loend?",
        deleteAllMessage: "Kas olete kindel, et soovite kustutada kõik {count} ülesannet seda autot jaoks? Seda toimingut ei saa tagasi võtta.",
        deleteAllSuccess: "Kõik ülesanded on edukalt kustutatud.",
        sortPriority: "Prioriteet",
        sortType: "Tüüp",
        sortDate: "Viimased",
        status: {
            overdue: "ÜLEKANDID",
            pending: "OOTESEISUS",
            noData: "ANDMED PUUDUVAD",
            upcoming: "Eelseisev",
            nextIn: "Järgmine {dist} {unit} pärast",
            overdueBy: "{dist} {unit} üle",
            afterDays: "{days} päeva pärast",
            overdueDays: "{days} päeva üle",
        },
        form: {
            newTitle: "Uus Ülesanne",
            actionType: "Kontrollida või Asendada?",
            intervalMonths: "Intervall (kuud)",
            intervalDistance: "Intervall (vahemaa)",
            diffFirstInterval: "Esimene intervall erineb põhivahest",
            firstInterval: "Esimene Intervall",
            historyToggle: "Kas seda ülesannet on kunagi selle auto jaoks tehtud?",
            historyToggleDesc: "Kui EI, siis eeldame, et seda pole kunagi tehtud alates tootmisest.",
            lastPerformedOptional: "Millal see viimati tehti? (Valikuline)",
            deleteTitle: "Kustuta Ülesanne",
            deleteConfirm: "Kas olete kindel, et soovite selle ülesande kustutada?",
            saveError: "Ülesande salvestamine ebaõnnestus",
            historyConfirmed: "Ajalugu Kinnitatud",
            reminders: "Meeldetuletused",
            notifyMileage: "Teata mulle, kui hinnanguline läbisõit on saavutatud",
            notifyDate: "Teata mulle, kui kuupäev on saavutatud",
            nextMileageReminder: "Hinnanguline kuupäev",
            nextDateReminder: "Tähtpäev",
            estimatedDate: "Eeldatav kuupäev",
            missingLastMileage: "Puudub viimane läbitud kilomeeter",
            missingLastDate: "Puudub viimane teostatud kuupäev",
            missingStartDate: "Ei õnnestunud määrata alguskuupäeva",
            additionalOptions: "Lisavalikud",
            reminderInfoMissing: "Teavitav olek: meeldetuletused on keelatud, kuni viimased teostatud andmed on esitatud.",
        },
    },
    dashboard: {
        title: "Ülevaade",
        quickActions: "Kiired Toimingud",
        addExpense: "Lisa kulu",
        editCar: "Muuda autot",
        recentExpenses: "Hiljutised kulud",
        seeAll: "Vaata kõiki",
        recentGallery: "Hiljutised Fotod",
        thisMonth: "Sel kuul",
        totalSpent: "Kokku kulutatud",
        avgPerMonth: "Keskmine/kuu",
        recentNotes: "Hiljutised Märkmed",
        recentParts: "Hiljutised Osad",
        noRecentExpenses: "Pole hiljutisi kulusid",
        noRecentGallery: "Pole hiljutisi fotosid",
        noRecentNotes: "Pole hiljutisi märkmeid",
        noRecentParts: "Pole hiljutisi osi",
        createNote: "Loo uus",
        createPart: "Loo uus",
        createExpense: "Loo uus",
        noFiles: "Faile pole veel lisatud",
        needSomethingMore: "Kas vajad midagi enamat?",
        letUsKnow: "anna meile teada!",
    },
    expenseTypes: {
        editTitle: "Muuda kulu tüüpi",
        newTitle: "Uus kulu tüüp",
        categoryName: "Kategooria nimi",
        placeholderName: "nt. Teenus",
        signatureColor: "Allkirja värv",
        icon: "Kategooria ikoon",
        deleteConfirm: "Kas oled kindel, et soovid kustutada tüübi '{name}'?",
    },
    spareParts: {
        title: "Varuosad",
        connectedWithRecords: "Seotud rekorditega",
        toBuy: "Ostmiseks",
        usedInExpenses: "Kasutatud kuludes",
        noPartsToBuy: "Ostukirjelduses pole osasid",
        noPartsUsed: "Kuludega pole veel osasid seotud",
        quantity: "Kogus",
        partCode: "Osakood",
        price: "Hind",
        link: "Link",
        comment: "Kommentaar",
        addPart: "Lisa varuosa",
        editPart: "Muuda varuosa",
        openPart: "Ava osa sisestus",
        nameLabel: "Nimi",
        manufacturerLabel: "Tootja",
        priceLabel: "Hind ({currency})",
        imagesLabel: "Images & Files (first one is primary)",
        linkedHistory: "Seotud ajalugu",
        partManagedNote: "See varuosa on hallatud kulude kaudu",
        cannotDeleteNote: "* Since this part is linked to an expense, it cannot be deleted separately. Delete or edit the expense to manage this part's lifecycle.",
        partNamePlaceholder: "Varuosa nimi...",
        manufacturerPlaceholder: "Bosch, Brembo jne.",
        additionalInfoPlaceholder: "Lisainformatsioon...",
        namePlaceholder: "nt. pidurid",
        codePlaceholder: "nt. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Salvesta varuosa",
        deletePart: "Delete Part",
        deleteConfirm: "Kas olete kindel, et soovite selle varuosa kustutada?",
        sparePartsLabel: "Varuosad",
        partNumber: "Varuosa #{number}",
        imagesLimitLabel: "Pildid ja failid (kuni 5)",
        optional: "(valikuline)",
        selectPart: "Vali varuosa",
        createNew: "Loo uus varuosa",
        searchPlaceholder: "Otsi nime või koodi järgi...",
        noResults: "Varuosi ei leitud",
        noPartsYet: "Varuosi pole veel. Loo oma esimene!",
        selectorDescription: "Leia ja vali olemasolev varuosa või loo uus",
        alreadyAdded: "See osa on juba lisatud",
        statistics: {
            avgPrice: "Keskmine",
            lastPrice: "Viimane",
            usedTimes: "Kasutatud {count} korda",
            totalPurchased: "Kokku: {quantity}x",
        },
        usage: {
            title: "See ost",
            quantity: "Kogus",
            pricePerUnit: "Hind ühiku kohta",
            comment: "Kommentaar",
            commentPlaceholder: "nt., Ostetud AutoZone'ist",
            total: "Kokku",
            transactionData: "See Tehing",
        },
        masterData: "Peamine Osa Info",
        masterRecord: {
            title: "Varuosa üksikasjad (jagatud)",
            editMaster: "Muuda põhikirjet",
            warning: "Muutused põhikirjes mõjutavad kõiki kasutusi",
        },
    },
    reminders: {
        title: "Meeldetuletused",
        reminder: "Meeldetuletus",
        noteReminder: "Märkus Meeldetuletus",
        partReminder: "Osa Meeldetuletus",
        today: "Täna",
        tomorrow: "Homme",
        yesterday: "Eile",
        inXDays: "{x} päeva pärast",
        xDaysAgo: "{x} päeva tagasi",
        inXMonths: "{x} kuu pärast",
        xMonthsAgo: "{x} kuud tagasi",
        active: "Aktiivne",
        activeDesc: "Vajadusel saate selle meeldetuletuse välja lülitada, ilma et seda kustutaksite",
        disabled: "Keelatud",
        yearly: "Aastane",
        markSeen: "Tunnusta",
        addReminder: "Uus Meeldetuletus",
        editReminder: "Muuda Meeldetuletust",
        extraReminders: "Lisa Meeldetuletused",
        extraRemindersDesc: "Saada 3 lisameeldetuletust järgmistel päevadel (kokku 4), kui ei peatata.",
        remindDate: "Kuupäev",
        remindTime: "Aeg",
        repeatYearly: "Korda Aastas",
        repeatYearlyDesc: "See meeldetuletus toimub automaatselt igal aastal samal kuupäeval/kuul/päeval/kellajal, kuni see on keelatud",
        standalone: "Iseseisvad Meeldetuletused",
        embedded: "Lingitud Meeldetuletused",
        noReminders: "Ei ole aktiivseid meeldetuletusi",
        deleteReminder: "Kustuta Meeldetuletus",
        nameLabel: "Nimi",
        descriptionLabel: "Kirjeldus",
        namePlaceholder: "Meeldetuletuse nimi",
        descriptionPlaceholder: "Lühike kirjeldus või märkus",
        simulateReminder: "Simuleeri meeldetuletuse hetke",
        simulateSuccess: "Simulatsiooni e-kiri saadetud",
        timezone: "Ajavahe",
        nextReminder: "Järgmine meeldetuletus",
        futureTimeError: "Meeldetuletuse aeg peab olema tulevikus",
    },
    notes: {
        title: "Märkmed",
        emptyNote: "Tühi märge",
        noNotes: "Märkmeid pole veel",
        addNote: "Lisa märge",
        editNote: "Muuda märget",
        viewNote: "Vaata märget",
        openNote: "Ava märkme sisestus",
        titleLabel: "Pealkiri",
        contentLabel: "Sisu",
        noteTitlePlaceholder: "Märge pealkiri...",
        noteContentPlaceholder: "Kirjuta oma märge siia...",
        saveNote: "Salvesta märge",
        deleteNote: "Kustuta märge",
        publicNote: "Tee märge avalikuks",
        publicNoteDesc: "Teised saavad seda märget vaadata jagatud lingi kaudu",
        deleteConfirm: "Kas olete kindel, et soovite selle märge kustutada?",
        enterTitleAlert: "Palun sisestage pealkiri",
        saveFailed: "Märge ei õnnestunud salvestada",
        thisNote: "See märge",
        deleteFailed: "Märge ei õnnestunud kustutada",
        pinToTop: "Kinnita ülaossa",
    },
    locations: {
        title: "Asukohad",
        singleTitle: "Asukoht",
        newLocation: "Uus asukoht",
        emptyLocation: "Tühi asukoht",
        noLocations: "No locations yet",
        addLocation: "Lisa asukoht",
        editLocation: "Muuda asukohta",
        viewLocation: "Vaata asukohta",
        openLocation: "Ava asukoht",
        createNew: "Loo uus asukoht",
        selectLocation: "Vali asukoht",
        searchLocations: "Otsi asukohti...",
        nameLabel: "Nimi",
        addressLabel: "Aadress või koordinaadid",
        descriptionLabel: "Kommentaar/Kirjeldus",
        namePlaceholder: "nt, Kesklinna teenus",
        mapLabel: "Asukoht",
        searchPlaceholder: "Otsi aadressi...",
        addressPlaceholder: "Sisestage aadress ja valige...",
        descriptionPlaceholder: "Lisainfo...",
        fillAddress: "Täida aadress kaardilt",
        saveLocation: "Salvesta asukoht",
        deleteLocation: "Kustuta asukoht",
        deleteConfirm: "Kas olete kindel, et soovite selle asukoha kustutada?",
        enterNameAlert: "Palun sisestage nimi",
        saveFailed: "Asukoha salvestamine ebaõnnestus",
        thisLocation: "See asukoht",
        deleteFailed: "Asukoha kustutamine ebaõnnestus",
        myLocations: "Minu asukohad",
        usedInEntries: "Kasutatud kirjetes",
        noEntries: "Asukohta ei kasutata",
        noEntriesThisCar: "Seda asukohta ei ole selle auto jaoks kasutatud",
        removeLocation: "Eemalda asukoht",
        noResults: "Tulemusi ei leitud",
    },
    gallery: {
        title: "Gallery",
        noImages: "Pilti ei ole lisatud",
        addImagesNote: "Lisa pilte autole või kuludele",
        totalImages: "Kokku {count} pilti",
        imageAlt: "Pilt {number}",
        commentPlaceholder: "Faili kommentaar",
        isReceipt: "See fail on kviitung",
        deleteImageTitle: "Kustuta fail",
        deleteImageConfirm: "Kas olete kindel, et soovite selle faili püsivalt kustutada?",
    },
    search: {
        placeholder: "Otsi kulusid, varuosi, märkmeid...",
        typeToSearch: "Alusta otsimist",
        noResults: "Tulemusi ei leitud '{query}'",
        carImage: "Auto pilt",
        expenseImage: "Kulu pilt",
        noteImage: "Märge pilt",
        galleryImage: "Galerii pilt",
        untitledExpense: "Pealkirjata kulu",
    },
    landing: {
        nav: {
            features: "Funktsioonid",
            howItWorks: "Kuidas see töötab",
            pricing: "Hinnakiri",
            login: "Logi sisse",
            getStarted: "Alusta",
            garage: "Garaaž",
        },
        hero: {
            title: "Tea Täpselt, Mida Sinu Auto",
            subtitle: "Tõeliselt Maksab",
            description: "Jälgi kulusid, logi remonti ja vaata, kuhu sinu raha tõeliselt läheb.",
            subheadline: "Professionaalne andmepõhine armatuurlaud hoolikatele autoomanikele.",
            startTracking: "Alusta",
            viewDemo: "Demo Auto ->",
            trustSignal: "Liituge 1200+ hoolika omanikuga, kes on juba kaardistanud üle 5 miljoni kilomeetri reaalseid autokulusid.",
            ctaNote: "Ei ole krediitkaarti. Ei ole pealetükkivat müüki. Ainult selgus.",
            benefits: {
                repairVsSell: {
                    title: `Remont vs. Müük`,
                    description: `Tuvastage "Remont vs. Müük" piir — Lõpetage muretsemine, kas investeerite raha rahakotti. Teadke täpselt hetke, mil remont ei ole enam nutikas investeering.`
                },
                costPerKm: {
                    title: `Kulud-kilomeetri kohta`,
                    description: `Jälgige oma tegelikke kulusid-kilomeetri kohta — Minge kaugemale armatuurlaudast. Näidake oma sõiduharjumuste täielikku finantspilti, mida teised rakendused ei hõlma.`
                },
                automation: {
                    title: `Automatiseerimine`,
                    description: `Automatiseerige oma andmete haldamine — Lihtsalt edastage oma arved või saatke oma märkmed e-posti teel. Meie AI korraldab teie auto tehnilise ajaloo teie eest.`
                }
            },
        },
        features: {
            title: "Kõik, mida vajad oma auto haldamiseks",
            subtitle: "Lõpeta tabelite ja segaste kaustade kasutamine. My Car Costs toob professionaalsed autopargi haldamise tööriistad sinu isiklikku garaaži.",
            expenseTracking: {
                title: "Kulude jälgimine",
                description: "Logi kütus, hooldus, kindlustus ja remont. Kategoriseeri kulud ja visualiseeri trende.",
            },
            spareParts: {
                title: "Varuosade haldur",
                description: "Hoia detailset inventuuri varuosadest, koodidest ja sobivuse märkmetest kõigi remontide jaoks.",
            },
            serviceHistory: {
                title: "Hooldusajalugu ja märkmed",
                description: "Hoia digitaalset hooldusraamatut. Lisa märkmeid hoolduse, modifikatsioonide või tulevikuplaanide kohta.",
            },
            documentStorage: {
                title: "Dokumendihoidla",
                description: "Laadi üles tšekid, arved ja fotod oma autost. Hoia kogu dokumentatsioon turvaliselt ja kättesaadavalt.",
            },
            emailForwarding: {
                title: "E-posti edastamine",
                description: "Saada arved otse oma unikaalsesse postkasti. Me ammutame andmed automaatselt.",
            },
            multiCar: {
                title: "Mitme auto garaaž",
                description: "Halda ühte autot või tervet autoparki. Vaheta sõidukeid hetkega.",
            },
            repeatingExpenses: {
                title: "Korduvad kulud",
                description: "Automatiseerige regulaarsete igakuiste kulude jälgimine, nagu kindlustus, parkimine või liising.",
            },
            smartReminders: {
                title: "Nutikaid meeldetuletusi",
                description: "Seadke kohandatud teavitused varuosade ja teenuse märkmete jaoks, et mitte jääda ilma hooldustööst.",
            },
        },
        howItWorks: {
            title: "Lihtne ja võimas voog",
            step1: {
                title: "Lisa oma sõiduk",
                description: "Sisesta auto andmed, et luua oma digitaalne garaaž.",
            },
            step2: {
                title: "Logi kulud ja failid",
                description: "Tee tšekist pilti või edasta e-kiri. Meie tegeleme ülejäänuga.",
            },
            step3: {
                title: "Saa ülevaade",
                description: "Näe oma kilomeetri hinda, igakuiseid kulutusi ja hoolduse ajajoont.",
            },
        },
        useCases: {
            title: "Ideaalne",
            enthusiasts: {
                title: "Autoentusiastidele",
                description: "Jälgi igat modifikatsiooni, varuosa koodi ja hooldusintervalli oma projekti jaoks.",
            },
            dailyDrivers: {
                title: "Igapäevajuhtidele",
                description: "Tea täpselt, kui palju su sõit maksab, ja ära kunagi maga hoolduse aega maha.",
            },
            flippers: {
                title: "Nutikas Flipper",
                description: "Koguge kontrollitav andmemaht, mis tõestab teie auto tõelist väärtust ostjatele.",
            },
            fleets: {
                title: "Väikestele autoparkidele",
                description: "Halda mitut ettevõtte sõidukit ühes kohas ilma keerulise tarkvarata.",
            },
        },
        foundersNote: {
            title: "Asutaja Märkus",
            content: "Ehitan MyCarCosts'i, et olla lõplik tööriist inimestele, kes tõeliselt hoolivad oma autodest. Kas teie töövoos puudub mõni funktsioon? Võtke minuga otse ühendust. Kui see on kogukonna jaoks mõistlik, ehitame selle koos.",
        },
        pricing: {
            freeLimitedTime: "Piiratud aja jooksul tasuta",
            title: "Lihtne ja läbipaistev hinnakiri",
            subtitle: "Alusta tasuta, uuenda kasvades.",
            perMonth: "kuu",
            monthly: "Kuu",
            yearly: "Aasta",
            save25: "Säästa 25%",
            billedAnnually: "Arveldatakse aastas ({amount})",
            free: {
                title: "Tasuta",
                cta: "Alusta",
            },
            pro: {
                title: "Pro",
                cta: "Uuenda Pro-ks",
                recommended: "Soovituslik",
                earlyAdopter: "Varajase liituja hind",
                priceLock: "Lukusta see hind kohe. Tulevikus võib hind tõusta.",
            },
            custom: {
                title: "Eritellimus",
                cta: "Võtke meiega ühendust",
            },
            features: {
                oneCar: "1 auto",
                unlimitedExpenses: "Piiramatud kuluartiklid",
                unlimitedSpareParts: "Piiramatu varuosade",
                unlimitedNotes: "Piiramatu märkmed",
                repeatedExpenses: "Korduvad kulud",
                emailReminders: "Märkmed ja varuosade e-posti meeldetuletused",
                basicStatistics: "Põhistatistika",
                fullStatistics: "Täisstatistika",
                storage50mb: "50 Mb failide salvestus",
                unlimitedArchivedCars: "Piiramatu arhiveeritud autod",
                dataExport: "Andmete eksport",
                allInFreePlus: "kõik tasuta pluss:",
                threeCars: "Kuni 3 autot",
                storage2gb: "2 Gb failide salvestus",
                emailParsing: "E-posti analüüs",
                carAdmins: "Auto administraatorid",
                moreCars: "Rohkem autosid",
                moreFileStorage: "Rohkem failide salvestust",
                customRequirements: "Erivajadused",
            },
            upgradePopup: {
                title: "Peagi tulekul!",
                message: "Pro ja kohandatud versioonid ei ole veel käivitatud, kuid need tulevad varsti. Aitame meil kiiremini käivitada - palun kirjutage, millist konkreetset funktsiooni te ootate pro / kohandatud versioonilt või midagi muud, mida soovite, et me parandaksime, et see platvorm oleks teie jaoks veelgi parem!",
                placeholder: "Kirjutage oma tagasiside siia...",
                submit: "Saada",
                cancel: "Tühista",
                thanksTitle: "Aitäh!",
                thanksMessage: "Oleme saanud teie tagasiside ja töötame selle nimel, et MyCarCosts oleks veelgi parem!",
                thanksOk: "Ok",
            },
        },
        migration: {
            title: "Kas liigute Excelist või mõnest muust rakendusest?",
            subtitle: "Pakume professionaalset andmete migreerimise teenust, et saaksite kohe tööd alustada.",
            pricingModel: "Hinnamudel",
            small: {
                title: "Väike andmestik",
                description: "< 500 rida",
                price: "19–29 $",
            },
            medium: {
                title: "Keskmine andmestik",
                description: "500–5,000 rida",
                price: "49 $",
            },
            large: {
                title: "Suur / Keeruline",
                description: "Vanad süsteemid või keerulised failid",
                price: "Eripakkumine",
            },
            process: {
                title: "Kuidas see toimib",
                step1: "Te esitate oma faili",
                step2: "Me hindame andmeid",
                step3: "Ühekordne makse",
                step4: "Me tegeleme impordiga",
            },
            cta: "Telli migreerimine",
        },
        repairAnalysisSection: {
            title: "Remontida või müüa? Las andmed otsustavad.",
            subtitle: "Professionaalne finantsanalüüs teie sõiduki jaoks. Lõpetage oletamine ja alustage teadmist, kas need remondid on tõeliselt väärt.",
            features: {
                personalized: {
                    title: "Isikupärastatud analüüs",
                    description: "Teie jälgitud autode jaoks kasutame tõelisi ajaloolisi kulusid ja parameetreid, lisades planeeritud kulud, et genereerida hindamine.",
                },
                public: {
                    title: "Avalik simulaator",
                    description: "Hindate potentsiaalset ostu? Kasutage meie avalikku tööriista aadressil /repair, et genereerida detailne analüüs, sisestades vaid mõned olulised üksikasjad.",
                },
                whatIf: {
                    title: "Mida-Kui Simulaator",
                    description: "Sisesta planeeritud remondi kulu ja vaata kohe, kuidas see mõjutab sinu auto finantsseisu.",
                },
            },
            cta: "Vaata Näidisanalüüsi",
        },
        faq: {
            title: "Korduma kippuvad küsimused",
            subtitle: "Kõik, mida pead teadma My Car Costs kohta",
            questions: {
                mobileApps: {
                    question: "Kas tulevad iOS ja Android äpid?",
                    answer: "Jah! Mobiiliäpid nii iOS-ile kui Androidile on peagi tulemas. Töötame kõvasti, et pakkuda teile parimat mobiilikogemust.",
                },
                dataPrivacy: {
                    question: "Kas minu andmed on privaatsed ja turvalised?",
                    answer: "Absoluutselt. Teie andmed on krüpteeritud ja hoitakse turvaliselt.",
                },
                freePlan: {
                    question: "Kas tasuta pakett on tõesti igavesti tasuta?",
                    answer: "Jah! Tasuta pakett on alati saadaval ühe autoga. Saate igal ajal uuendada Pro paketile kuni 3 auto jaoks.",
                },
                dataExport: {
                    question: "Kas ma saan oma andmeid eksportida?",
                    answer: "Jah, saate igal ajal eksportida kõik oma andmed CSV või PDF vormingus.",
                },
                emailImport: {
                    question: "Kuidas toimib e-posti import?",
                    answer: "Igal autol on unikaalne e-posti aadress. Edasta oma arved ja me ammutame andmed.",
                },
                multipleUsers: {
                    question: "Kas mitu inimest saavad samale autole ligi?",
                    answer: "Hetkel kuulub iga auto ühele kontole. Küll aga saate teha auto avalikuks, et jagada teistele vaatamisõigust.",
                },
            },
        },
        cta: {
            title: "Lõpeta oletamine. Alusta teadmist.",
            subtitle: "Muuda oma auto ajalugu selgeteks finantsotsusteks. Ühine tuhandete nutikate omanikega, kes teavad täpselt, millal investeerida või müüa.",
            button: "Alusta kohe",
            note: "Ei ole krediitkaarti. Ei ole pealetükkivat müüki. Ainult selgus.",
        },
        footer: {
            product: "Toode",
            legal: "Õiguslik teave",
            changelog: "Muudatuste logi",
            privacy: "Privatsuspoliitika",
            contact: "Kontakt",
            contactEmail: "info@mycarcosts.com",
            questions: "Küsimusi? Võtke meiega ühendust aadressil:",
        },
        privacy: {
            title: "Privatsuspoliitika",
            lastUpdated: "Viimati uuendatud: 25. märts 2026",
            introduction: "Me suhtume teie privaatsusesse tõsiselt. See poliitika selgitab, kuidas me teie andmeid käsitleme.",
            dataCollection: {
                title: "Andmete kogumine",
                description: "Kogume ainult absoluutset minimaalset teavet, mis on vajalik meie teenuse osutamiseks.",
                email: "Konto identiteet: Kasutame teie e-posti aadressi teie ainulaadse identifikaatorina ja autentimiseks (nt maagilised lingid või Google'i sisselogimine).",
                documents: "Dokumendi salvestamine: Failid, mida te üles laadite, salvestatakse turvaliselt krüpteeritud pilvesalvestusse.",
            },
            carData: {
                title: "Teie andmete kontroll",
                description: "Teave, mille te sisestate (kulud, läbisõit, osad), salvestatakse teie isiklikuks kasutamiseks ja analüüsiks.",
                noValidation: "Me ei valideeri teie esitatud auto andmeid; teie vastutate täpsuse tagamise eest.",
                privateByDefault: "Vaikimisi on teie andmed privaatne. Failide tehnilised identifikaatorid ei ole järjestikused ja neid ei indekseeri otsingumootorid.",
                rightToForgotten: "Õigus unustada: Saate oma konto igal ajal kustutada, mis kohe ja püsivalt eemaldab kõik teie andmed ja failid.",
            },
            thirdParty: {
                title: "Kolmandate osapoolte teenused",
                description: "Me ei müü teie isikuandmeid. Google'i sisselogimise kasutamisel pääseme tuvastamise eesmärgil juurde ainult teie e-posti aadressile.",
            },
            emailIngestion: {
                title: "E-kirjade vastuvõtt",
                description: "Meie vastuvõtuteenusele saadetud e-kirjad salvestatakse töötlemise ajaloo pakkumiseks. Saate igal ajal käsitsi kustutada üksikuid e-kirju või kogu oma ajaloo.",
            },
        },
        emails: {
            deleteAll: "Kustuta kõik",
            deleteAllConfirm: "Kas olete kindel, et soovite kustutada selle auto kogu e-kirjade ajaloo? See toiming on pöördumatu.",
            deleteConfirm: "Kas olete kindel, et soovite selle e-kirja kustutada?",
            noEmails: "E-kirju pole veel saabunud.",
        },
        terms: {
            title: "Kasutustingimused",
            lastUpdated: "Viimati uuendatud: 25. märts 2026",
            introduction: "Kasutades MyCarCosts teenust, nõustute järgima käesolevaid kasutustingimusi. Kui te ei nõustu, palume meie teenust mitte kasutada.",
            acceptance: {
                title: "1. Tingimustega nõustumine",
                description: "Käesolevad tingimused moodustavad juriidiliselt siduva lepingu teie ja MyCarCosts vahel seoses meie rakenduse ja teenuste kasutamisega.",
            },
            service: {
                title: "2. Teenuse kirjeldus",
                description: "MyCarCosts pakub platvormi sõidukite kulude jälgimiseks, hoolduse haldamiseks ja finantsanalüüsiks. See hõlmab AI-toega kviitungite analüüsi ja andmete visualiseerimise tööriistu.",
            },
            responsibilities: {
                title: "3. Kasutaja kohustused",
                description: "Vastutate kõigi sisestatud andmete, sealhulgas läbisõidu, VIN-koodide ja kulude täpsuse eest. Peate hoidma oma sisselogimisandmed (e-post/maagiline link) turvaliselt ega tohi neid jagada volitamata isikutega.",
            },
            plans: {
                title: "4. Teenusplaanid ja piirangud",
                description: "Pakume tasuta ja Pro-plaane erinevate salvestusmahu, autode arvu ja üleslaadimise piirangutega. Jätame endale õiguse neid piiranguid igal ajal muuta või uusi tellimustasemeid kehtestada.",
            },
            disclaimer: {
                title: "5. Vastutuse välistamine ja täpsus",
                description: "MyCarCosts on informatiivne ja organisatsiooniline tööriist. Me ei väljasta ametlikke sõiduki seisukorra sertifikaate. Kasutaja peaks alati kontrollima AI-ga analüüsitud kviitungite andmete täpsust.",
            },
            liability: {
                title: "6. Vastutuse piiramine",
                description: "MyCarCosts teenust pakutakse 'nagu on' kujul. Me ei vastuta mehaaniliste probleemide, finantskahjude ega andmete ebatäpsuste eest, mis tulenevad meie rakenduse kasutamisest.",
            },
            termination: {
                title: "7. Lõpetamine",
                description: "Võite teenuse kasutamise lõpetada ja oma andmed igal ajal kustutada. Jätame endale õiguse peatada tai tühistada kontod, mis rikuvad neid tingimusi või näitavad kuritarvitavat käitumist.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

